// Page Documentations

import Documentation from '../views/Documentation'
import Typography from '../views/Documentation/Typography'
import Color from '../views/Documentation/Color'
import ChannelCard from '../views/Documentation/ChannelCard'
import SavedCard from '../views/Documentation/SavedCard'
import CollectionCard from '../views/Documentation/CollectionCard'
import CategoryCard from '../views/Documentation/CategoryCard'
import ListItems from '../views/Documentation/ListItems'
import Button from '../views/Documentation/Button'
import CampaignEditor from '../views/Documentation/CampaignEditorGroup'
import AlertWide from '../views/Documentation/AlertWide'
import Alert from '../views/Documentation/Alert'
import Badge from '../views/Documentation/Badge'
import Image from '../views/Documentation/Image'
import SubMenuBar from '../views/Documentation/SubMenuBar'
import Form from '../views/Documentation/Form'
import FormAbstraction from '../views/Documentation/FormAbstraction'
import Pagination from '../views/Documentation/Pagination'
import Search from '../views/Documentation/Search'
import Dropdown from '../views/Documentation/Dropdown'
import Loading from '../views/Documentation/Loading'
import FAB from '../views/Documentation/FAB'
import Modal from '../views/Documentation/Modal'
import MenuExpansion from '../views/Documentation/MenuExpansion'
import ProgressBar from '../views/Documentation/ProgressBar'
import Calendar from '../views/Documentation/Calendar'
import QuickFilter from '../views/Documentation/QuickFilter'
import Tooltip from '../views/Documentation/Tooltip'
import StyleGuide from '../views/Documentation/StyleGuide'
import Dummy from '../views/Documentation/Dummy'
import Discussions from '../views/Documentation/Discussions'
import StatusLabel from '../views/Documentation/StatusLabel'
import BreadCrumb from '../views/Documentation/BreadCrumb'
import GallerySlideShow from '../views/Documentation/GallerySlideShow'
import Table from '../views/Documentation/Table'
import File from '../views/Documentation/File'
import MultipleDropdown from '../views/Documentation/MultipleDropdown'
import ExpandableListItems from '../views/Documentation/ExpandableListItems'
import BarPercentage from '../views/Documentation/BarPercentage'


const documentationMenu = [
    {
      path: '/documentation',
      name: 'documentation',
      component: Documentation,
      meta: { isSuperuser: true },
      children: [
        {
          path: 'dummy',
          name: 'dummy',
          component: Dummy,
          meta: { isSuperuser: true }
        },
        {
          path: 'typography',
          name: 'typography',
          component: Typography,
          meta: { isSuperuser: true }
        },
        {
          path: 'color',
          name: 'color',
          component: Color,
          meta: { isSuperuser: true }
        },
        {
          path: 'channelcard',
          name: 'channelcard',
          component: ChannelCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'savedcard',
          name: 'savedcard',
          component: SavedCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'collectioncard',
          name: 'collectioncard',
          component: CollectionCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'categorycard',
          name: 'categorycard',
          component: CategoryCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'listitems',
          name: 'listitems',
          component: ListItems,
          meta: { isSuperuser: true }
        },
        {
          path: 'button',
          name: 'button',
          component: Button,
          meta: { isSuperuser: true }
        },
        {
          path: 'campaigneditor',
          name: 'campaigneditor',
          component: CampaignEditor,
          meta: { isSuperuser: true }
        },
        {
          path: 'alertwide',
          name: 'alertwide',
          component: AlertWide,
          meta: { isSuperuser: true }
        },
        {
          path: 'alert',
          name: 'alert',
          component: Alert,
          meta: { isSuperuser: true }
        },
        {
          path: 'badge',
          name: 'badge',
          component: Badge,
          meta: { isSuperuser: true }
        },
        {
          path: 'image',
          name: 'image',
          component: Image,
          meta: { isSuperuser: true }
        },
        {
          path: 'submenubar',
          name: 'submenubar',
          component: SubMenuBar,
          meta: { isSuperuser: true }
        },
        {
          path: 'form',
          name: 'form',
          component: Form,
          meta: { isSuperuser: true }
        },
        {
            path: 'formabstraction',
            name: 'formabstraction',
            component: FormAbstraction,
            meta: { isSuperuser: true }
        },
        {
          path: 'pagination',
          name: 'pagination',
          component: Pagination,
          meta: { isSuperuser: true }
        },
        {
          path: 'search',
          name: 'search',
          component: Search,
          meta: { isSuperuser: true }
        },
        {
          path: 'dropdown',
          name: 'dropdown',
          component: Dropdown,
          meta: { isSuperuser: true }
        },
        {
          path: 'multipledropdown',
          name: 'multipledropdown',
          component: MultipleDropdown,
          meta: { isSuperuser: true }
        },
        {
          path: 'progressbar',
          name: 'progressbar',
          component: ProgressBar,
          meta: { isSuperuser: true }
        },
        {
          path: 'loading',
          name: 'loading',
          component: Loading,
          meta: { isSuperuser: true }
        },
        {
          path: 'fab',
          name: 'fab',
          component: FAB,
          meta: { isSuperuser: true }
        },
        {
          path: 'modal',
          name: 'modal',
          component: Modal,
          meta: { isSuperuser: true }
        },
        {
          path: 'menuexpansion',
          name: 'menuexpansion',
          component: MenuExpansion,
          meta: { isSuperuser: true }
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: Calendar,
          meta: { isSuperuser: true }
        },
        {
          path: 'quickfilter',
          name: 'quickfilter',
          component: QuickFilter,
          meta: { isSuperuser: true }
        },
        {
          path: 'tooltip',
          name: 'tooltip',
          component: Tooltip,
          meta: { isSuperuser: true }
        },
        {
          path: 'file',
          name: 'file',
          component: File,
          meta: { isSuperuser: true }
        },
        {
          path: 'styleguide',
          name: 'styleguide',
          component: StyleGuide,
          meta: { isSuperuser: true }
        },
        {
          path: 'discussions',
          name: 'discussions',
          component: Discussions,
          meta: { isSuperuser: true }
        },
        {
          path: 'statuslabel',
          name: 'statuslabel',
          component: StatusLabel,
          meta: { isSuperuser: true }
        },
        {
          path: 'breadcrumb',
          name: 'breadcrumb',
          component: BreadCrumb,
          meta: { isSuperuser: true }
        },
        {
          path: 'galleryslideshow',
          name: 'galleryslideshow',
          component: GallerySlideShow,
          meta: { isSuperuser: true }
        },
        {
          path: 'table',
          name: 'table',
          component: Table,
          meta: { isSuperuser: true }
        },
        {
          path: 'expandablelistitems',
          name: 'expandablelistitems',
          component: ExpandableListItems,
          meta: { isSuperuser: true }
        },
        {
          path: 'barpercentage',
          name: 'barpercentage',
          component: BarPercentage,
          meta: { isSuperuser: true }
        },
      ]
    },
]

export default documentationMenu;
